import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import cx from "classnames";

import MarketFilterCategories from "./MarketFilterCategories";
import ResetFiltersButton from "./ResetFiltersButton";

import s from "./FiltersDialog.module.scss";

export default function FiltersDialog({
	categories,
	toggleCategory = () => {},
	resetFilters = () => {},
	close = () => {},
}) {
	return (
		<Modal centered isOpen={true} className={cx(s.root, "dialog-md")}>
			<ModalHeader toggle={close}>
				<p className={s.header}>Category Filters</p>
			</ModalHeader>

			<ModalBody className={s.content}>
				<MarketFilterCategories
					categories={categories}
					className={s.categories}
					toggleCategory={toggleCategory}
					resetFilters={resetFilters}
				/>

				<ResetFiltersButton resetFilters={resetFilters} className={s.reset} />
			</ModalBody>
		</Modal>
	);
}
